/**
 * Created by Ivan on 10.08.2026
 */

const StickersComponent2 = function (collection) {
    return Prefab.instantiate(bundles.stickers2_collection_window.jsons.stickers_component_prefab_json, { collection });
};
